import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/app/services/user.service';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { GlobalService } from 'src/app/services/global.service';
import VanillaTilt from 'vanilla-tilt';

@Component({
  selector: 'sd-epk-dialog',
  templateUrl: './epk-dialog.component.html',
  styleUrls: ['./epk-dialog.component.scss']
})
export class EpkDialogComponent implements OnInit {

  constructor(
    public user: UserService,
    public global: GlobalService,
    public dialogRef: MatDialogRef<EpkDialogComponent>,

  ) {
    /*console.log(this.user.id, this.user.id != 0)
    this.global.cookie = this.global.getCookie('epkpopup')
    if (!this.global.cookie && this.user.id != 0) {
      this.global.setCookie('epkpopup', 'true', 3)
    }*/
  }

  ngOnInit(): void {



   


  }

  closeDialog() {
    this.dialogRef.close('');


  }






}
